@if (!errorType) {
<tec-pwcs-layout [ngClass]="{ dark: designService.isDarkMode() }"
    [title]="tutorial ? '' : 'CONNECTIONS.TYPES.SCRIPTURE' | translate"
    [subtitle]="tutorial ? ('CONNECTIONS.SCRIPTURE.TUTORIAL_TITLE' | translate) : ('CONNECTIONS.SCRIPTURE.TITLE' | translate)"
    [footerLabel]="tutorial ? ('GENERAL.TUTORIAL_CONNECTION_ENCRYPTION' | translate) : ''">

    <tec-progress [value]="progressService.getValue()"></tec-progress>

    <ng-container content>
        @if (tutorial) {
            <pwcs-inline-svg
                [src]="'assets/images/connection-escrituras-tutorial' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                idSuffix="connection-escrituras-tutorial"
            />
        } @else if (!formCifComplete) {
            <tec-tile [formGroup]="form" class="custom-tile">
                <tec-form-group [label]="'CONNECTIONS.SCRIPTURE.FORM.CIF' | translate"
                    [errorMsg]="reactiveFormService.hasMsgError(form.get('cif'))">
                    <tec-input
                        formControlName="cif"
                        [placeholder]="'CONNECTIONS.SCRIPTURE.FORM.CIF_PLACEHOLDER' | translate"
                        [hasError]="reactiveFormService.hasError(form.get('cif'))"
                    ></tec-input>
                </tec-form-group>
            </tec-tile>
        }
    </ng-container>
    <ng-container actions>
        @if (tutorial) {
            <tec-button
                size="lg"
                [label]="'GENERAL.BUTTON.CONTINUE' | translate"
                (clickEvent)="finishTutorial()"
            ></tec-button>
        } @else if (!formCifComplete) {
            <tec-button
                size="lg"
                [label]="'GENERAL.BUTTON.CONTINUE' | translate"
                (clickEvent)="initScriptureRobot()"
            ></tec-button>
        }
    </ng-container>

    <!-- NAV HELP -->
    <tec-nav-help
        [elements]="tutorial ? navsHelpTutorial : navsHelp"
        (clickEvent)="navHelpChange($event)"
    ></tec-nav-help>
</tec-pwcs-layout>
}

<app-modal-scan-qr
    [ngClass]="{ dark: designService.isDarkMode() }"
    [(isVisible)]="isVisibleScan"
    [url]="auth.getQRUrl()"
></app-modal-scan-qr>

<!-- ERRORS -->
@if (errorType) {
<tec-pwcs-layout [ngClass]="{ dark: designService.isDarkMode()}">
    <ng-container content>
        @switch (errorType) {
            @case ('PRE_2009') {
                <tec-tile
                    type="status"
                    [title]="'CONNECTIONS.SCRIPTURE.ERROR.PRE_2009_TITLE' | translate"
                    [subtitle]="errorDescriptionKey('PRE_2009') | translate"
                    tagIconStatus="default"
                    icon="icon-alert"
                ></tec-tile>
            }
            @case ('PERSON_NOT_MATCHED') {
                <tec-tile
                    type="status"
                    [title]="'CONNECTIONS.SCRIPTURE.ERROR.PERSON_NOT_MATCHED_TITLE' | translate"
                    [subtitle]="errorDescriptionKey('PERSON_NOT_MATCHED') | translate"
                    tagIconStatus="default"
                    icon="icon-alert"
                ></tec-tile>
            }
            @case ('COMPANY_NOT_ACTIVE') {
                <tec-tile
                    type="status"
                    [title]="'CONNECTIONS.SCRIPTURE.ERROR.INACTIVE_TITLE' | translate"
                    [subtitle]="errorDescriptionKey('INACTIVE') | translate"
                    tagIconStatus="default"
                    icon="icon-alert"
                ></tec-tile>
            }
            @case ('NOT-SCRIPTURE') {
                <tec-tile
                    type="status"
                    [title]="'CONNECTIONS.SCRIPTURE.ERROR.NOT_SCRIPTURE_TITLE' | translate"
                    [subtitle]="errorDescriptionKey('NOT_SCRIPTURE') | translate"
                    tagIconStatus="default"
                    icon="icon-alert"
                ></tec-tile>
            }
            @case ('ERROR') {
                <tec-tile
                    type="status"
                    [title]="'CONNECTIONS.SCRIPTURE.ERROR.SERVER_TITLE' | translate"
                    [subtitle]="'CONNECTIONS.SCRIPTURE.ERROR.SERVER_DESCRIPTION' | translate"
                    tagIconStatus="default"
                    icon="icon-alert"
                ></tec-tile>
            }
        }
    </ng-container>
    <ng-container actions>
        @switch (errorType) {
            @case ('PRE_2009') {
                @if (operation.config?.numberOfTries < operation.config?.total_tries) {
                <tec-button
                    [type]="!hasManualFallback ? 'default' : 'secondary'"
                    [size]="'lg'"
                    [label]="'GENERAL.BUTTON.RETRY' | translate"
                    (clickEvent)="initScriptureRobot()"
                ></tec-button>
                }
                @if (hasManualFallback) {
                <tec-button
                    [type]="'default'"
                    icon="icon-upload"
                    iconPosition="left"
                    [size]="'lg'"
                    [label]="'GENERAL.BUTTON.ATTACH_SCRIPTURE' | translate"
                    (clickEvent)="changeToManualUpload()"
                ></tec-button>
                }
            }
            @case ('PERSON_NOT_MATCHED') {
                @if (operation.config?.numberOfTries < operation.config?.total_tries) {
                <tec-button
                    [type]="!hasManualFallback ? 'default' : 'secondary'"
                    [size]="'lg'"
                    [label]="'GENERAL.BUTTON.RETRY' | translate"
                    (clickEvent)="initScriptureRobot()"
                ></tec-button>
                }
                @if (hasManualFallback) {
                <tec-button
                    [type]="'default'"
                    icon="icon-upload"
                    iconPosition="left"
                    [size]="'lg'"
                    [label]="'GENERAL.BUTTON.ATTACH_SCRIPTURE' | translate"
                    (clickEvent)="changeToManualUpload()"
                ></tec-button>
                }
            }
            @case ('NOT-SCRIPTURE') {
                @if (operation.config?.numberOfTries < operation.config?.total_tries) {
                <tec-button
                    [type]="!hasManualFallback ? 'default' : 'secondary'"
                    [size]="'lg'"
                    [label]="'GENERAL.BUTTON.RETRY' | translate"
                    (clickEvent)="initScriptureRobot()"
                ></tec-button>
                }
                @if (hasManualFallback) {
                <tec-button
                    [type]="'default'"
                    icon="icon-upload"
                    iconPosition="left"
                    [size]="'lg'"
                    [label]="'GENERAL.BUTTON.ATTACH_SCRIPTURE' | translate"
                    (clickEvent)="changeToManualUpload()"
                ></tec-button>
                }
            }
            @case ('COMPANY_NOT_ACTIVE') {
                @if (operation.config?.numberOfTries < operation.config?.total_tries) {
                <tec-button
                    [type]="!hasManualFallback ? 'default' : 'secondary'"
                    [size]="'lg'"
                    [label]="'GENERAL.BUTTON.RETRY' | translate"
                    (clickEvent)="initScriptureRobot()"
                ></tec-button>
                }
                @if (hasManualFallback) {
                <tec-button
                    icon="icon-upload"
                    iconPosition="left"
                    [type]="'default'"
                    [size]="'lg'"
                    [label]="'GENERAL.BUTTON.ATTACH_SCRIPTURE' | translate"
                    (clickEvent)="changeToManualUpload()"
                ></tec-button>
                }
            }
            @case ('ERROR') {
                @if (hasManualFallback) {
                <tec-button
                    icon="icon-upload"
                    iconPosition="left"
                    [type]="'default'"
                    [size]="'lg'"
                    [label]="'GENERAL.BUTTON.ATTACH_SCRIPTURE' | translate"
                    (clickEvent)="changeToManualUpload()"
                ></tec-button>
                }
            }
        }
    </ng-container>
</tec-pwcs-layout>
}